module.exports = __webpack_public_path__ + "img/2.9fc7188b.png";